module.exports = __webpack_public_path__ + "static/media/profile-strength.017b9a94.png";